import React from 'react';

export function FallBack() {
  return <div>...</div>;
}

export default FallBack;
